(ns machtfit.stepchall.countdown
  (:require [clojure.string :as str]
            [goog.string :as gstring]
            [machtfit.translation :refer [tr trn]]))

(defn countdown [{:keys [from until dative?]}]
  (let [seconds-total (- until from)
        seconds-total (+ seconds-total 60) ;; the last 60 seconds should show as "1 minute left", not "0 minutes left".
        minutes-total (quot seconds-total 60)
        minutes (rem minutes-total 60)
        hours-total (quot minutes-total 60)
        hours (rem hours-total 24)
        days (quot hours-total 24)
        days-string (gstring/format (trn "%d Tag" (str "%d Tage" (when dative? "n")) days) days)
        hours-string (gstring/format (trn "%d Stunde" "%d Stunden" hours) hours)
        minutes-string (gstring/format (trn "%d Minute" "%d Minuten" minutes) minutes)
        show-days? (> days 0)
        show-hours? (and (< days 3) (not= hours 0))
        show-minutes? (and (= days 0) (or (= hours 0) (not= minutes 0)))]
    (cond-> []
      show-days? (conj days-string)
      show-hours? (conj hours-string)
      show-minutes? (conj minutes-string)
      true (->> (str/join (str " " (tr "und") " "))))))
